import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Spin from "antd/lib/spin";
import compose from "lodash/flowRight";
import PropTypes from "prop-types";
import * as React from "react";

import * as authService from "../../common/authService";
import * as usersService from "../../common/usersService";
import ConnectionsGraph from "../../components/ConnectionsGraph";
import CurrentUserConnections from "../../components/CurrentUserConnections";
import { withData } from "../../components/DataFetcher";
import { withOperation } from "../../components/OperationPerformer";

class Connections extends React.Component {
    static propTypes = {
        toggleConnection: PropTypes.func.isRequired,
        togglingConnection: PropTypes.bool.isRequired,
        fetchingUsers: PropTypes.bool.isRequired,
        users: PropTypes.array
    };

    constructor(props) {
        super(props);
        this.state = {
            showGraph: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.users !== nextProps.users) {
            this.setState({ showGraph: true });
        }
    }

    renderConnections() {
        if (
            this.state.showGraph &&
            authService.getCurrentUser().email.includes("@mondora.com")
        ) {
            return (
                <Row gutter={16} className="full-height">
                    <Col span={6} className="full-height">
                        <CurrentUserConnections
                            currentUserUid={authService.getCurrentUser().uid}
                            onToggleConnection={this.props.toggleConnection}
                            togglingConnection={this.props.togglingConnection}
                            fetchingUsers={this.props.fetchingUsers}
                            users={this.props.users}
                        />
                    </Col>
                    <Col span={18} className="full-height">
                        <ConnectionsGraph users={this.props.users} />
                    </Col>
                </Row>
            );
        } else if (!this.props.fetchingUsers) {
            return (
                <Row gutter={16} className="full-height">
                    <Col span={22} className="full-height">
                        <h1 align="center">
                            Puoi accedere solo con un'utenza :M
                        </h1>
                    </Col>
                </Row>
            );
        }
    }

    render() {
        return (
            <Spin
                wrapperClassName="full-height"
                spinning={this.props.fetchingUsers && !this.props.users}
                size="large"
            >
                {this.renderConnections()}
            </Spin>
        );
    }
}

export default compose(
    withOperation({
        operation: usersService.toggleCurrentUserConnectionWith,
        mapOperationToProps: toggleConnection => ({ toggleConnection }),
        mapOperationStateToProps: ({ performing }) => ({
            togglingConnection: performing
        })
    }),
    withData({
        getQuery: usersService.getAllUsersQuery,
        mapQueryStateToProps: ({ fetching, data, error }) => ({
            fetchingUsers: fetching,
            users: data
        })
    })
)(Connections);



// WEBPACK FOOTER //
// ./src/views/Connections/index.js